import { CheckCircle2 } from "lucide-react";

const ProblemPromise = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
          Freelancing is freedom. Your tools shouldn't feel like a full-time job.
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Problem */}
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold text-foreground">The Problem</h3>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Most freelancers are running their business across scattered tools: spreadsheets for money, 
              notes apps for clients, random task apps for projects, and a half-remembered CRM inside their inbox. 
              The result? Missed follow-ups, delayed invoices, and no clear picture of how the business is actually doing.
            </p>
          </div>

          {/* Promise */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold text-foreground">
              Catlyo becomes your personal business partner.
            </h3>
            <ul className="space-y-4">
              {[
                "One place for clients, projects, tasks, invoices, finance, and goals.",
                "A Super Queue that tells you exactly what to do next.",
                "Clean dashboards that show what you've earned, what's due, and what's at risk.",
                "An AI co-founder that thinks in revenue and priorities — not just text."
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="h-6 w-6 text-primary shrink-0 mt-0.5" />
                  <span className="text-lg text-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemPromise;
